import React from "react";
import { Link } from "react-router-dom";
import "../App.css";

function Nav({ isAuthenticated }) {
  return (
    isAuthenticated && (
      <nav>
        <ul>
          <li className="nav__link">
            <Link to="/upload-topics" className="nav__link--anchor">
              Upload Topics
            </Link>
          </li>
          <li className="nav__link">
            <Link to="/upload-questions" className="nav__link--anchor">
              Upload Questions
            </Link>
          </li>
          <li className="nav__link">
            <Link to="/view-topics" className="nav__link--anchor">
              View Topics (Logs)
            </Link>
          </li>
          <li className="nav__link">
            <Link to="/view-questions" className="nav__link--anchor">
              View Questions (Logs)
            </Link>
          </li>
          <li className="nav__link">
            <Link to="/my-teacher-stats" className="nav__link--anchor">
              MyTeacher stats
            </Link>
          </li>
        </ul>
      </nav>
    )
  );
}

export default Nav;
